import { ProgressPayload } from '@/services/TaskRunner/ITaskRunner'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IDepositCollectionValidationResult } from '../depositValidation/models/DepositCollectionValidationResult'

interface RestakingDepositValidationState {
  input: string
  validationResult?: IDepositCollectionValidationResult | undefined
  validationProgress?: ProgressPayload | undefined
  validating: boolean
}

const initialState: RestakingDepositValidationState = {
  input: '',
  validating: false,
}

const restakingDepositValidationSlice = createSlice({
  name: 'restakingDepositValidation',
  initialState,
  reducers: {
    setDepositCollectionInput: (state, { payload }: PayloadAction<string>) => {
      if (state.validating)
        throw new Error('Cannot change input while validating')

      state.input = payload
      state.validationResult = undefined
      state.validationProgress = undefined
    },
    setValidationProgress: (
      state,
      { payload }: PayloadAction<ProgressPayload>
    ) => {
      state.validationProgress = payload
    },
    setValidationResult: (
      state,
      { payload }: PayloadAction<IDepositCollectionValidationResult>
    ) => {
      state.validationResult = payload
    },
    setValidating: (state, { payload }: PayloadAction<boolean>) => {
      state.validating = payload
    },
  },
})

export const {
  setDepositCollectionInput,
  setValidating,
  setValidationProgress,
  setValidationResult,
} = restakingDepositValidationSlice.actions
export default restakingDepositValidationSlice.reducer
